<template>
  <div class="homepage">
    <HeroSection />
    <FeaturesSection />
    <AboutSection />
    <ContactSection />
  </div>
</template>

<script setup>
import HeroSection from '@/components/HeroSection.vue'
import FeaturesSection from '@/components/FeaturesSection.vue'
import AboutSection from '@/components/AboutSection.vue'
import ContactSection from '@/components/ContactSection.vue'
</script>

<style scoped>
.homepage {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}
</style>